import { render } from "./PaymentSelectCompanyDialog.vue?vue&type=template&id=a56d79a0&scoped=true"
import script from "./PaymentSelectCompanyDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentSelectCompanyDialog.vue?vue&type=script&lang=ts"

import "./PaymentSelectCompanyDialog.vue?vue&type=style&index=0&id=a56d79a0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a56d79a0"

export default script